import { CommunitySchoolType } from 'types/settings/communityschool'
import { create } from 'zustand'

const communitySchool = (set: any) => ({
  addCommunitySchoolModal: false,
  setAddCommunitySchoolModal: (value: boolean) =>
    set({ addCommunitySchoolModal: value }),
  communitySchoolData: undefined,
  setCommunitySchoolData: (state: CommunitySchoolType) =>
    set({ communitySchoolData: state }),
})

export const CommunitySchoolStore = create(communitySchool)
